import { notification } from 'antd'
import axios from '../axios'
import userPool from '../userpool'

export async function get(url) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve, reject) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          reject(err)
        }
        axios
          .get(url, {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
          })
          .then((response) => {
            resolve(response.data)
          })
          .catch(() => {
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  return false
}

export async function post(url, payload, successMessage = 'Success', errorMessage = 'Error') {
  const cognitoUser = userPool.getCurrentUser()
  return new Promise((resolve, reject) => {
    cognitoUser.getSession((err, session) => {
      if (err) {
        reject(err)
      }
      axios
        .post(
          url,
          { ...payload },
          {
            headers: {
              Authorization: session.idToken.jwtToken,
            },
          },
        )
        .then(() => {
          notification.success({ message: successMessage })
          resolve(true)
        })
        .catch((err) => {
          notification.error({ message: err?.response?.data || errorMessage })
          resolve(false)
        })
    })
  })
}

export async function getAdminViaData(url, data) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve, reject) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          reject(err)
        }
        axios
          .get(url, {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
            params: data.payload, // Send data as query parameters
          })
          .then((response) => {
            resolve(response.data)
            console.log('Admin VIA Data:', response.data)
          })
          .catch(() => {
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  return false
}

// GET /admin/via/missions with query params
export async function getViaMissions(params) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          notification.error({ message: 'Session expired. Please login again.' })
          resolve(false)
          return
        }
        axios
          .get('/admin/via/missions', {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
            params,
          })
          .then((response) => {
            resolve(response.data)
          })
          .catch((err) => {
            const message = err?.response?.data || 'Error fetching missions'
            notification.error({ message })
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  return false
}

// POST /admin/via/missions to create a mission
export async function createViaMission(payload) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          notification.error({ message: 'Session expired. Please login again.' })
          resolve(false)
          return
        }
        axios
          .post('/admin/via/missions', payload, {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
          })
          .then((response) => {
            notification.success({ message: 'Mission created' })
            resolve(response.data)
          })
          .catch((err) => {
            const messageText = err?.response?.data || 'Error creating mission'
            notification.error({ message: messageText })
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  notification.error({ message: 'Not logged in. Please login first.' })
  return false
}

// PUT /admin/via/missions to update a mission
export async function updateViaMission(payload) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          notification.error({ message: 'Session expired. Please login again.' })
          resolve(false)
          return
        }
        axios
          .put('/admin/via/missions', payload, {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
          })
          .then((response) => {
            notification.success({ message: 'Mission updated' })
            resolve(response.data)
          })
          .catch((err) => {
            const messageText = err?.response?.data || 'Error updating mission'
            notification.error({ message: messageText })
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  notification.error({ message: 'Not logged in. Please login first.' })
  return false
}

// DELETE /admin/via/missions to delete a mission
export async function deleteViaMission(payload) {
  const cognitoUser = userPool.getCurrentUser()
  function getCurrentUser() {
    return new Promise((resolve) => {
      cognitoUser.getSession((err, session) => {
        if (err) {
          notification.error({ message: 'Session expired. Please login again.' })
          resolve(false)
          return
        }
        axios
          .delete('/admin/via/missions', {
            headers: {
              Authorization: `${session.idToken.jwtToken}`,
            },
            data: payload,
          })
          .then((response) => {
            notification.success({ message: 'Mission deleted successfully' })
            resolve(response.data)
          })
          .catch((err) => {
            const messageText = err?.response?.data || 'Error deleting mission'
            notification.error({ message: messageText })
            resolve(false)
          })
      })
    })
  }
  if (cognitoUser != null) return getCurrentUser()

  notification.error({ message: 'Not logged in. Please login first.' })
  return false
}